import { Component } from '@angular/core';

@Component({
  selector: 'app-load-component',
  templateUrl: './load-component.component.html',
  styleUrls: ['./load-component.component.scss']
})
export class LoadComponentComponent {
}
